import login from "./auth/login";
import confirm from "./auth/confirm";
import logout from "./auth/logout";

export default {
    login,
    confirm,
    logout,
}